import React from 'react';
import { Phone, Video, MessageSquare, Calendar, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { ContactForm } from '../components/ContactForm';
interface BeratungPageProps {
  onNavigate: (page: string) => void;
}
export function BeratungPage({
  onNavigate
}: BeratungPageProps) {
  return <div className="min-h-screen bg-white" data-id="element-334">
      <div className="bg-slate-50 py-20 border-b border-slate-200" data-id="element-335">
        <div className="container mx-auto px-4 text-center" data-id="element-336">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-337">
            Persönliche Premium-Beratung
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-338">
            Technologie ist gut, Expertenwissen ist besser. Sprechen Sie mit
            unseren zertifizierten Versicherungsfachleuten.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-339">
        <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-340">
          {/* Left Column: Info */}
          <div className="space-y-16" data-id="element-341">
            <section data-id="element-342">
              <h2 className="text-3xl font-bold mb-8 text-slate-900" data-id="element-343">
                So funktioniert's
              </h2>
              <div className="space-y-8" data-id="element-344">
                <div className="flex gap-6 relative" data-id="element-345">
                  <div className="absolute left-6 top-10 bottom-0 w-0.5 bg-slate-200 -z-10" data-id="element-346"></div>
                  <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg shadow-lg shadow-blue-200" data-id="element-347">
                    1
                  </div>
                  <div className="pb-4" data-id="element-348">
                    <h3 className="font-bold text-xl mb-2 text-slate-900" data-id="element-349">
                      Termin vereinbaren
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-350">
                      Wählen Sie einen passenden Zeitpunkt in unserem
                      Online-Kalender. Flexibel und einfach.
                    </p>
                  </div>
                </div>
                <div className="flex gap-6 relative" data-id="element-351">
                  <div className="absolute left-6 top-10 bottom-0 w-0.5 bg-slate-200 -z-10" data-id="element-352"></div>
                  <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg shadow-lg shadow-blue-200" data-id="element-353">
                    2
                  </div>
                  <div className="pb-4" data-id="element-354">
                    <h3 className="font-bold text-xl mb-2 text-slate-900" data-id="element-355">
                      Exklusive Beratung erhalten
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-356">
                      Per Video, Telefon oder Chat. Bequem von zu Hause aus mit
                      Screen-Sharing.
                    </p>
                  </div>
                </div>
                <div className="flex gap-6" data-id="element-357">
                  <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-lg shadow-lg shadow-blue-200" data-id="element-358">
                    3
                  </div>
                  <div data-id="element-359">
                    <h3 className="font-bold text-xl mb-2 text-slate-900" data-id="element-360">
                      Entscheidung treffen
                    </h3>
                    <p className="text-slate-600 text-lg" data-id="element-361">
                      Sie erhalten ein maßgeschneidertes Konzept und entscheiden
                      in Ruhe. Ohne Druck.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section data-id="element-362">
              <h2 className="text-3xl font-bold mb-8 text-slate-900" data-id="element-363">
                Ihre Vorteile
              </h2>
              <div className="grid sm:grid-cols-2 gap-6" data-id="element-364">
                <Card className="hover:border-blue-300 transition-colors" data-id="element-365">
                  <CardContent className="p-6 flex items-center gap-4" data-id="element-366">
                    <div className="bg-blue-50 p-3 rounded-lg" data-id="element-367">
                      <Video className="h-6 w-6 text-blue-600" data-id="element-368" />
                    </div>
                    <span className="font-bold text-slate-800" data-id="element-369">
                      Video-Beratung
                    </span>
                  </CardContent>
                </Card>
                <Card className="hover:border-blue-300 transition-colors" data-id="element-370">
                  <CardContent className="p-6 flex items-center gap-4" data-id="element-371">
                    <div className="bg-blue-50 p-3 rounded-lg" data-id="element-372">
                      <Phone className="h-6 w-6 text-blue-600" data-id="element-373" />
                    </div>
                    <span className="font-bold text-slate-800" data-id="element-374">
                      Rückruf-Service
                    </span>
                  </CardContent>
                </Card>
                <Card className="hover:border-blue-300 transition-colors" data-id="element-375">
                  <CardContent className="p-6 flex items-center gap-4" data-id="element-376">
                    <div className="bg-blue-50 p-3 rounded-lg" data-id="element-377">
                      <MessageSquare className="h-6 w-6 text-blue-600" data-id="element-378" />
                    </div>
                    <span className="font-bold text-slate-800" data-id="element-379">Live-Chat</span>
                  </CardContent>
                </Card>
                <Card className="hover:border-blue-300 transition-colors" data-id="element-380">
                  <CardContent className="p-6 flex items-center gap-4" data-id="element-381">
                    <div className="bg-blue-50 p-3 rounded-lg" data-id="element-382">
                      <Calendar className="h-6 w-6 text-blue-600" data-id="element-383" />
                    </div>
                    <span className="font-bold text-slate-800" data-id="element-384">
                      Flexible Zeiten
                    </span>
                  </CardContent>
                </Card>
              </div>
            </section>
          </div>

          {/* Right Column: Form */}
          <div className="lg:sticky lg:top-24" data-id="element-385">
            <div className="bg-white rounded-3xl shadow-2xl p-1 border border-slate-100 overflow-hidden" data-id="element-386">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white p-8 text-center" data-id="element-387">
                <h3 className="text-2xl font-bold mb-2" data-id="element-388">
                  Jetzt Termin anfragen
                </h3>
                <p className="text-blue-100" data-id="element-389">Kostenlos und unverbindlich</p>
              </div>
              <div className="p-8" data-id="element-390">
                <ContactForm data-id="element-391" />
              </div>
            </div>

            <div className="mt-8 flex items-center justify-center gap-6 text-sm text-slate-500" data-id="element-392">
              <div className="flex items-center gap-2" data-id="element-393">
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-394" />{' '}
                Zertifizierte Experten
              </div>
              <div className="flex items-center gap-2" data-id="element-395">
                <CheckCircle2 className="h-4 w-4 text-green-500" data-id="element-396" /> Unabhängig
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}